import React from 'react';
import Picker from './Picker';

const TimesheetDialog = ({
  dialogRef,
  draft,
  draftProjectId,
  draftTaskId,
  draftTasks,
  error,
  isLoading,
  onBackdropClick,
  onChange,
  onSubmit,
  projects,
  t,
  theme,
}) => (
  <dialog
    ref={dialogRef}
    onClick={onBackdropClick}
    className="timesheets-dialog"
    style={{ background: theme.surface, color: theme.text, borderColor: theme.border }}
  >
    <form className="timesheets-create" onSubmit={onSubmit}>
      <h3 className="timesheets-subtitle">
        {draft.id ? t('editTimesheet') || 'Edit Timesheet' : t('addTimesheet') || 'Add Timesheet'}
      </h3>

      {error && (
        <p className="timesheets-status" style={{ color: theme.error }}>
          {error.message}
        </p>
      )}

      <Picker
        id="draft-projects"
        name="project"
        label={t('project') || 'Project'}
        placeholder={t('selectProject') || 'Select Project'}
        options={projects}
        value={draft.project}
        onChange={onChange}
        disabled={Boolean(draft.id)}
        theme={theme}
      />

      <Picker
        id="draft-tasks"
        name="task"
        label={t('task') || 'Task'}
        placeholder={t('selectTask') || 'Select Task'}
        options={draftTasks}
        value={draft.task}
        onChange={onChange}
        disabled={Boolean(draft.id) || !draftProjectId}
        theme={theme}
      />

      <label className="timesheets-field">
        <span>{t('date') || 'Date'}</span>
        <input
          type="date"
          name="date"
          required
          disabled={Boolean(draft.id)}
          value={draft.date}
          onChange={onChange}
          style={{ borderColor: theme.border, color: theme.text }}
        />
      </label>

      <fieldset className="timesheets-duration">
        <legend>{t('time') || 'Time'}</legend>
        <div className="timesheets-duration-row">
          <label className="timesheets-field">
            <span>{t('hours') || 'Hours'}</span>
            <input
              type="number"
              name="hours"
              min="0"
              required
              placeholder="0"
              value={draft.hours}
              onChange={onChange}
              style={{ borderColor: theme.border, color: theme.text }}
            />
          </label>
          <label className="timesheets-field">
            <span>{t('minutes') || 'Minutes'}</span>
            <input
              type="number"
              name="minutes"
              min="0"
              max="59"
              placeholder="0"
              value={draft.minutes || '0'}
              onChange={onChange}
              style={{ borderColor: theme.border, color: theme.text }}
            />
          </label>
        </div>
      </fieldset>

      <label className="timesheets-field">
        <span>{t('description') || 'Description'}</span>
        <input
          type="text"
          name="description"
          value={draft.description}
          onChange={onChange}
          style={{ borderColor: theme.border, color: theme.text }}
        />
      </label>

      <div className="timesheets-dialog-actions">
        <button
          type="button"
          className="timesheets-cancel"
          onClick={() => dialogRef.current?.close()}
          style={{ borderColor: theme.border, color: theme.text }}
        >
          {t('cancel') || 'Cancel'}
        </button>
        <button
          type="submit"
          className="timesheets-submit"
          disabled={isLoading || (!draft.id && !draftTaskId)}
          style={{ background: theme.primary }}
        >
          {draft.id ? t('save') || 'Save' : t('add') || 'Add'}
        </button>
      </div>
    </form>
  </dialog>
);

export default TimesheetDialog;
